// @ts-nocheck
import { Breadcrumb, BreadcrumbItem, Col, Container, LinkList, LinkListItem, Row, Card, CardBody, CardTitle, CardText, CardReadMore } from 'design-react-kit';
import React, { useState, useContext } from 'react';
import WidgetSearch from '../../pages/components/widget_search';
import ApiService from '../../../services/api';
import { useEffect } from 'react';
import { WidgetClass } from '../../pages/models/widget';
import WidgetTags from 'apps/tags/components/widget_tags';
import WidgetPageRating from 'pa_kit/apps/page_evaluation/components/widget_page_rating';
import WidgetContacts from 'pa_kit/apps/contacts/components/widget_contacts';
import { ActaAuthContext } from "pa_kit/auth";
import { LocalSettingsContext } from "services/local_settings";
import parse from 'html-react-parser';
import { Helmet } from "react-helmet-async";


const PageDocuments = () => {

    const auth = useContext(ActaAuthContext);
    const settings = useContext(LocalSettingsContext);

    const localSettings = settings.localSettings;
    const organization = auth.organization;

    const documentsParentCategory = localSettings.documents_parent_category_data === null ? '' : localSettings.documents_parent_category_data.title
    const documentsParentCategorySlug = localSettings.documents_parent_category_data === null ? '' : localSettings.documents_parent_category_data.slug

    const [ categoryList, setCategoryList ] = useState();
    const [ mainSection, setMainSection ] = useState({});

    const [ widgetSearch ] = useState(new WidgetClass({
        name: "SearchSection",
        class: "search-alldocuments-section",
        type: "search",
        label: "Cerca documenti e dati",
        search_in: "main_sections",
        search_id: 2
    }));

    const [ widgetTags ] = useState(new WidgetClass({
        name: "TagsSection",
        class: "tags-section",
        type: "tags",
        list_style: "chips" 
    }));

    const fetchCategoryList = async () => {
        let categoryArray = [];
        let documentsCategoryList = await ApiService.getCategoryList();
        documentsCategoryList = documentsCategoryList.filter(category => category.is_document === true);
      
        // Filter categories where is_document is true and parent is empty
        let categoryList = documentsCategoryList.filter(category => category.parent === '');
      
        // Sort categoryList by name
        categoryList = categoryList.slice().sort((a, b) => a.name.localeCompare(b.name));
      
        // Function to recursively check for documents in category and its children
        const hasDocumentsInCategoryOrChildren = async (categoryId) => {
            const documents = await ApiService.getLatestDocumentsByCategory(categoryId);
            if (documents.length > 0) {
                return true;
            }
      
            // Check for documents in children
            const children = documentsCategoryList.filter(category => category.parent.id === categoryId);
            if(children.length > 0) {
                return true;
            }
        
            return false;
        };
      
        // Use Promise.all to get documents for each category
        await Promise.all(categoryList.map(async (category) => {
          if (await hasDocumentsInCategoryOrChildren(category.id)) {
            categoryArray.push(category.id);
          }
        }));
      
        // Filter categories based on the categoryArray
        const categoryDocuments = categoryList.filter(cat => categoryArray.includes(cat.id));
      
        // Set the state with the filtered categories
        setCategoryList(categoryDocuments);
    };

    const fetchMainSections = async() => {
        const mainSectionsData = await ApiService.getMainSections();
        const mainSection = mainSectionsData.filter(main_section => main_section.id === 2); // Documenti e Dati
        setMainSection(mainSection[0]);
    }

    useEffect(() => {
        fetchCategoryList();
        fetchMainSections();
    }, []);

    return <>
        <Helmet>
            <title>{mainSection.name + ' | ' + organization.name}</title>
            <meta name="description" content={mainSection.description} />
        </Helmet>
        <Container fluid className="p-0 documents-main-wrapper">
            <Container className="pt-5 px-3">
                <Row>
                    <Col>
                        <Breadcrumb>
                            <BreadcrumbItem>
                                <a href='/'>Home</a>
                                <span className='separator'>/</span>
                            </BreadcrumbItem>
                            {documentsParentCategory !== ''
                                && 
                                <BreadcrumbItem>
                                    <a href={'/' + documentsParentCategorySlug}>{documentsParentCategory}</a>
                                    <span className='separator'>/</span>
                                </BreadcrumbItem>
                            }
                            <BreadcrumbItem>
                                {mainSection.name}
                            </BreadcrumbItem>
                        </Breadcrumb>
                    </Col>
                </Row>
            </Container>

            <Container className={'page-title documents-page-title-page pb-5'}>
                <Row>
                    <Col lg="7">
                        <h1>{mainSection.name}</h1>
                        <div className="mt-4">{mainSection.description}</div>
                        <WidgetSearch widget={widgetSearch} />
                    </Col>
                    <Col lg="5">
                    <Container fluid className={'documents-page-menu page-menu-content ms-lg-5 ps-lg-5'}>
                        <p className="menu-name mb-2">{mainSection.name}</p>
                        <LinkList>
                            {categoryList && categoryList.map((category) => 
                                category.alt_link 
                                    ? <LinkListItem key={"key_menuItem_" + category.name} href={category.alt_link}  target="_blank" rel="noreferrer" className="ps-0 menu-item-link">{category.name}</LinkListItem>
                                    : <LinkListItem key={"key_menuItem_" + category.name} href={'/documenti-e-dati/' + category.slug + '/'} className="ps-0 menu-item-link">{category.name}</LinkListItem>                                
                            )}
                        </LinkList>
                    </Container>
                    </Col>
                </Row>
            </Container>

            <Container className='documents-menu page-menu-content mb-5 pb-5'>
                <h2 className="pt-5">Tutti i documenti</h2>
                <Row>
                {categoryList && categoryList.map((category) =>                
                    <Col xs='12' lg='4' className="mt-4" key={"key_cardItem_" + category.id}>                    
                        <Card className="menu-card border border-light shadow-sm">
                            <CardBody>
                                <CardTitle tag='h3' className='big-heading'>
                                    {category.alt_link 
                                        ? <a href={category.alt_link} target="_blank" rel="noreferrer" className="text-decoration-none me-2" title={category.name}>{category.name}</a>
                                        : <a href={'/documenti-e-dati/' + category.slug + '/'} className="text-decoration-none me-2" title={category.name}>{category.name}</a>
                                    }
                                </CardTitle>
                                <CardText>
                                    {parse(category.description.replace(/(<([^>]+)>)/gi, ""))}
                                </CardText>
                                {category.alt_link
                                    ? <CardReadMore href={category.alt_link} target="_blank" rel="noreferrer" text='Vai alla pagina' iconName='it-arrow-right' />
                                    : <CardReadMore href={'/documenti-e-dati/' + category.slug + '/'} text='Vai alla pagina' iconName='it-arrow-right' />
                                }                                
                            </CardBody>
                        </Card>
                    </Col>
                )}
                </Row>
            </Container>

            <Container className="mt-5">
                <h2 className="news-page-category-title mb-4 px-1">Argomenti</h2>  
            </Container> 

            <Container className="text-center mb-5">
                <WidgetTags widget={widgetTags} />
            </Container> 

            <Container fluid className={'rating-wrapper page-rating documents-page-rating'}>
                <WidgetPageRating page_title={mainSection.name} />
            </Container>

            <Container fluid className={'contacts-wrapper documents-page-contacts'}>
                <WidgetContacts />
            </Container>

        </Container>       
    </>;
}

export default PageDocuments;